import { render, staticRenderFns } from "./AlarmSetupTable.vue?vue&type=template&id=88bed914"
import script from "./AlarmSetupTable.vue?vue&type=script&lang=ts"
export * from "./AlarmSetupTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports